class StorageClass {
  private readonly storage: Storage;
  private readonly name: string;

  constructor(storage: Storage, name: string) {
    this.storage = storage;
    this.name = name;
  }

  save(key: string, data: unknown) {
    try {
      const dataJSON = JSON.stringify(data);

      this.storage.setItem(key, dataJSON);
    } catch (err) {
      console.error(`${key} saving to ${this.name} error: `, err);
    }
  }

  get(key: string) {
    try {
      const data = this.storage.getItem(key);

      return data ? JSON.parse(data) : data;
    } catch (err) {
      console.error(`${key} getting from ${this.name} error: `, err);
    }
  }

  clear() {
    try {
      this.storage.clear();
    } catch (err) {
      console.error(`Clearing ${this.name} error: `, err);
    }
  }

  remove(key: string) {
    try {
      this.storage.removeItem(key);
    } catch (err) {
      console.error(`${key} removing from ${this.name} error: `, err);
    }
  }
}

export const localStorage = new StorageClass(window.localStorage, 'localStorage');
export const sessionStorage = new StorageClass(window.sessionStorage, 'sessionStorage');
